// extracted by mini-css-extract-plugin
export default {"container":"Order_container__ky5zZ","heading":"Order_heading__BcGLL"};